import React from 'react'
import cls from 'classnames'
import styled from 'styled-components'

/**
 * Font Awesome 3.2.1
 * https://fontawesome.com/v3.2.1/icons/
 */

class IconFA extends React.Component {
  handlerOnClick = (e) => {
    const { disabled, onClick } = this.props
    if (!disabled && typeof onClick === 'function') onClick(e)
  }

  render() {
    const { name, className, title, id } = this.props

    // TODO: implement error throw
    if (!name) return ''

    return (
      <i
        id={id}
        name={name}
        title={title || ''}
        className={cls('tm-icon', `icon-${name}`, className)}
        onClick={this.handlerOnClick}
      />
    )
  }
}

export default styled(IconFA)`
  color: ${(props) => props.color || 'inherit'};
  font-size: ${(props) => (props.size ? props.size : '14px')};
  position: relative;
  display: inline-block;
  cursor: pointer;
  ${(props) => props.marginRight && `margin-right: ${props.marginRight};`}
  ${(props) =>
    props.rotate &&
    `
    animation:spin 2s linear infinite;
    @keyframes spin {
      0% {
        transform:rotate(0deg);
      }
      100% {
        transform:rotate(360deg);
      }
    }
  `}
`
